import { compose } from 'redux';
import { connect } from 'react-redux';
import CountdownView from '../../../common/countdown/countdownView';
import { goToQuestion } from '../../../common/navigation/navigationActions';
import { WR } from '../../../constants/measure';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';

const avatarMapStateToProps = () => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
    };
};

const mapDispatchToProps = dispatch => ({
    onEndCounting: () => dispatch(goToQuestion(WR.KEY, null, 1)),
});

const WRCountdownContainer = compose(
    connect(null, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(CountdownView);

export default WRCountdownContainer;
